import React, { useState } from "react";
import { TextField, Button, Box, Typography, Container, Snackbar, Alert } from "@mui/material";
import axios from "axios";


const Contact = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar mesajı
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Snackbar türü ("success" veya "error")
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSendEmail = async (e) => {
    e.preventDefault();
    if(!formData.name,!formData.email,!formData.subject,!formData.message){
      alert("Lütfen gerekli alanları doldurunuz")
      return
    }

    try {

      setIsSubmitting(true);
      await axios.post("https://kariyer.biyomed.net/api/email/sendContactEmail", formData);
      setSnackbarMessage("Mesajınız gönderildi!");
      setSnackbarSeverity("success");
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      setSnackbarMessage("Mesaj gönderiminde bir sorun oluştu.");
      setSnackbarSeverity("error");
    } finally {
      setIsSubmitting(false);
      setOpenSnackbar(true);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };
  return (
    <div className="jp_contact_form_main_wrapper">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="jp_contact_form_heading_wrapper">
              <h2>İletişim</h2>
            </div>
          </div>
          <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
            <div className="jp_contact_form_box">
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div className="jp_contact_inputs_wrapper">
                  <i className="fa fa-user" />
                  <input type="text" placeholder="Ad Soyad" name="name" value={formData.name}
                    onChange={handleChange} />
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div className="jp_contact_inputs_wrapper jp_contact_inputs2_wrapper">
                  <i className="fa fa-envelope" />
                  <input type="text" placeholder="Email" name="email" value={formData.email} onChange={handleChange} />
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="jp_contact_inputs_wrapper jp_contact_inputs3_wrapper">
                  <i className="fa fa-pencil-square-o" />
                  <input type="text" placeholder="Konu" name="subject" value={formData.subject} onChange={handleChange} />
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="jp_contact_inputs_wrapper jp_contact_inputs4_wrapper">
                  <i className="fa fa-text-height" />
                  <textarea
                    rows={6}
                    placeholder="Mesaj Bırakın"
                    value={formData.message}
                    onChange={handleChange}
                    name="message"
                  />
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="jp_contact_form_btn_wrapper">
                  <ul>
                    <li>
                      <a
                        onClick={!isSubmitting ? handleSendEmail : undefined}
                        role="button"
                        style={{ pointerEvents: isSubmitting ? "none" : "auto", opacity: isSubmitting ? 0.6 : 1 }}
                      >
                        <i className="fa fa-plus-circle" />
                        &nbsp; Gönder
                      </a>

                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div className="jp_contact_right_box_wrapper">
              <div className="jp_contact_form_add_heading_wrapper">
                <h2>İletişim Bilgileri</h2>
              </div>
              <div className="jp_form_add_wrapper gc_map_add_wrapper1">
                <div className="jp_map_location_icon_wrapper">
                  <i className="fa fa-map-marker" />
                </div>
                <div className="gc_map_location_icon_cont_wrapper">
                  <h3>Beştepe Mh. Nergiz Sk N 7/2 Ofis:27 06560 Yenimahalle/Ankara</h3>
                </div>
              </div>
              <div className="jp_form_add_wrapper gc_map_add_wrapper2">
                <div className="jp_map_location_icon_wrapper">
                  <i className="fa fa-phone" />
                </div>
                <div className="gc_map_location_icon_cont_wrapper gc_map_location_icon_cont_wrapper2">
                  <h3>0533 359 0718</h3>
                </div>
              </div>
              {/* <div className="jp_form_add_wrapper gc_map_add_wrapper2">
            <div className="jp_map_location_icon_wrapper">
              <i className="fa fa-fax" />
            </div>
            <div className="gc_map_location_icon_cont_wrapper gc_map_location_icon_cont_wrapper3">
              <h3>0533 359 0718</h3>
            </div>
          </div> */}
              <div className="jp_form_add_wrapper gc_map_add_wrapper3">
                <div className="jp_map_location_icon_wrapper">
                  <i className="fa fa-envelope" />
                </div>
                <div className="gc_map_location_icon_cont_wrapper gc_map_location_icon_cont_wrapper4">
                  <h3>
                    {" "}
                    <a href="/">kariyer@biyomed.net</a>
                  </h3>
                </div>
              </div>
              <div className="jp_contact_form_social_icon">
                <ul>
                  <li className="hidden-xs">
                    <a href="https://www.linkedin.com/company/biyomed/">
                      <i className="fa fa-linkedin" />
                    </a>
                  </li>

                  <li>
                    <a href="/https://www.instagram.com/biyomed.official/">
                      <i className="fa fa-instagram" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/channel/UCmy1lQQVYVuOEhWCQo0I2Hw">
                      <i className="fa fa-youtube" />
                    </a>
                  </li>

                  <li className="hidden-xs">
                    <a href="https://x.com/biyomed">
                      <i className="fa fa-twitter" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>

  )
}

export default Contact